import { render, staticRenderFns } from "./GlobalSwitchComponent.vue?vue&type=template&id=3fecd92f&scoped=true"
import script from "./GlobalSwitchComponent.vue?vue&type=script&lang=js"
export * from "./GlobalSwitchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fecd92f",
  null
  
)

export default component.exports